function initEncript () {
  const elPasswordInput = document.getElementById('pass')
  if (elPasswordInput) {
    console.log('Registering Enter for decrypt≈。');
    elPasswordInput.onkeypress = function (keyPressEvent) {

      if (keyPressEvent.keyCode === 13) {

        typeof decryptAES === 'function' && decryptAES();

      }

    };
  }
}
module.exports = initEncript;